import { render, staticRenderFns } from "./controlModel.vue?vue&type=template&id=4f4755b8"
import script from "./controlModel.vue?vue&type=script&lang=js"
export * from "./controlModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4755b8')) {
      api.createRecord('4f4755b8', component.options)
    } else {
      api.reload('4f4755b8', component.options)
    }
    module.hot.accept("./controlModel.vue?vue&type=template&id=4f4755b8", function () {
      api.rerender('4f4755b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/controlManage/controlModel.vue"
export default component.exports